import { registerPlugin } from '@capacitor/core';

export interface UPIApp {
  displayName: string;
  id: string;
  icon: string; // base64-encoded
}

export interface UPIIntentCheckoutOptions {
  paymentSessionId: string;
  orderId: string;
  environment: 'SANDBOX' | 'PRODUCTION';
}

export interface UPIIntentCheckoutResult {
  status: 'SUCCESS' | 'FAILED';
  orderId: string;
  errorMessage?: string;
  errorCode?: string;
  errorType?: string;
}

export interface CashfreeUpiPlugin {
  startDropCheckout(options: UPIIntentCheckoutOptions): Promise<UPIIntentCheckoutResult>;
  startUPIIntentCheckout(options: UPIIntentCheckoutOptions): Promise<UPIIntentCheckoutResult>;
  getInstalledUPIApps(): Promise<{ apps: UPIApp[] }>;
}

const CashfreeUpi = registerPlugin<CashfreeUpiPlugin>('CashfreeUpi');

export default CashfreeUpi;
